<template>
  <div>
    <!-- Sección de conexión -->
    <div class="margin-general offer_">
      <div class="title">
        <h3>{{ $t("market.titleoffer") }}</h3>
        <p class="body-4">{{ $t("market.descriptoffer") }}</p>
      </div>
      <div class="card_cont">
        <!-- Render cards dynamically -->
        <div class="card" v-for="card in cards" :key="card.id">
          <div class="cont">
            <span class="material-symbols-outlined" translate="no">{{ card.imgSrc }}</span>
            <p class="body-3">{{ $t(card.paragraphKey) }}</p>
            <p class="body-4">{{ $t(card.subparagraphKey) }}</p>
          </div>
          <div class="btn">
            <NuxtLink :to="localPath(card.link)">
              <button class="second-button-small">
                {{ $t(card.linkKey) }}
              </button>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const localPath = useLocalePath();

const cards = ref([
  {
    id: 1,
    imgSrc: "currency_exchange",
    paragraphKey: "market.paragraph1",
    subparagraphKey: "market.subparagraph1",
    linkKey: "market.link1",
    link: "/trading/markets/forex",
  },
  {
    id: 2,
    imgSrc: "chat",
    paragraphKey: "market.paragraph2",
    subparagraphKey: "market.subparagraph2",
    linkKey: "market.link2",
    link: "/trading/markets/stocks",
  },
  /* {
    id: 3,
    imgSrc: "handshake",
    paragraphKey: "market.paragraph3",
    subparagraphKey: "market.subparagraph3",
    linkKey: "market.link3",
    link: "/trading/markets/futures",
  }, */
  {
    id: 4,
    imgSrc: "oil_barrel",
    paragraphKey: "market.paragraph4",
    subparagraphKey: "market.subparagraph4",
    linkKey: "market.link4",
    link: "/trading/markets/commodities",
  },
  {
    id: 5,
    imgSrc: "finance_mode",
    paragraphKey: "market.paragraph5",
    subparagraphKey: "market.subparagraph5",
    linkKey: "market.link5",
    link: "/trading/markets/indices",
  },
]);
</script>